import { render, staticRenderFns } from "./SmartServiceMessage.vue?vue&type=template&id=0f3a1852&scoped=true&"
import script from "./SmartServiceMessage.vue?vue&type=script&lang=js&"
export * from "./SmartServiceMessage.vue?vue&type=script&lang=js&"
import style0 from "./SmartServiceMessage.vue?vue&type=style&index=0&id=0f3a1852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a1852",
  null
  
)

export default component.exports